export const getExcludedEmailsKey = (emails: string[] = []) =>
  [...new Set(emails.map((email) => email.trim().toLowerCase()).filter(Boolean))].sort().join(';')
